module.exports = __webpack_public_path__ + "img/icons/arrow-left.svg";